var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cn from 'classnames';
import omit from 'lodash/omit';
import React, { forwardRef } from 'react';
import EdsAvatar from '@ellucian/react-design-system/core/es/Avatar';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    marginLeftRight: {
        marginLeft: Tokens.spacing30,
        marginRight: Tokens.spacing30
    },
    marginTopBottom: {
        marginBottom: Tokens.spacing30,
        marginTop: Tokens.spacing30
    },
    marginTopBottom2: {
        marginBottom: Tokens.spacing20,
        marginTop: Tokens.spacing20
    },
    error: {
        backgroundColor: Tokens.colorFillAlertError,
        color: Tokens.colorTextNeutral100
    },
    info: {
        backgroundColor: Tokens.colorFillAlertNeutral,
        color: Tokens.colorTextNeutral100
    },
    large: {
        height: Tokens.sizingLarge,
        width: Tokens.sizingLarge
    },
    medium: {
        height: Tokens.sizingMedium,
        width: Tokens.sizingMedium
    },
    noMargin: {
        margin: `${Tokens.spacingReset}${Tokens.important}`
    },
    noMarginLeft: {
        marginLeft: `${Tokens.spacingReset}${Tokens.important}`
    },
    noMarginRight: {
        marginRight: `${Tokens.spacingReset}${Tokens.important}`
    },
    noPadding: {
        padding: `${Tokens.spacingReset}${Tokens.important}`
    },
    root: {},
    small: {
        height: Tokens.spacing40,
        width: Tokens.spacing40
    },
    success: {
        backgroundColor: Tokens.colorFillAlertSuccess,
        color: Tokens.colorTextNeutral100
    },
    warning: {
        backgroundColor: Tokens.colorFillAlertWarning,
        color: Tokens.colorTextNeutral100
    },
    xLarge: {
        height: Tokens.sizingXLarge,
        width: Tokens.sizingXLarge
    },
    xxLarge: {
        fontSize: Tokens.fontSizeHeader2,
        height: Tokens.sizingXxLarge,
        width: Tokens.sizingXxLarge
    },
    xxLarge1: {
        fontSize: Tokens.fontSizeHeader2,
        height: Tokens.sizingXxLarge1,
        width: Tokens.sizingXxLarge1
    },
    xxxLarge: {
        fontSize: Tokens.spacing80,
        height: '120px',
        width: '120px'
    }
});
const Avatar = (props, ref) => {
    const { classes, background, backgroundNumber, className, children, marginLeftRight, marginTopBottom, marginTopBottom2, noMargin, noMarginLeft, noMarginRight, size } = props, rest = __rest(props, ["classes", "background", "backgroundNumber", "className", "children", "marginLeftRight", "marginTopBottom", "marginTopBottom2", "noMargin", "noMarginLeft", "noMarginRight", "size"]);
    let classAvatar;
    let color;
    if (background) {
        switch (background) {
            case 'error':
                classAvatar = cn(classAvatar, classes.error);
                break;
            case 'info':
                classAvatar = cn(classAvatar, classes.info);
                break;
            case 'success':
                classAvatar = cn(classAvatar, classes.success);
                break;
            case 'warning':
                classAvatar = cn(classAvatar, classes.warning);
                break;
            default:
                color = background;
                break;
        }
    }
    else if (backgroundNumber) {
        switch (backgroundNumber) {
            case 1:
                color = 'purple';
                break;
            case 2:
                color = 'tangerine';
                break;
            case 3:
                color = 'kiwi';
                break;
            case 4:
                color = 'saffron';
                break;
            case 5:
                color = 'fountain';
                break;
            case 6:
                color = 'iris';
                break;
            case 7:
                color = 'meadow';
                break;
            default:
                color = 'default';
                break;
        }
    }
    let classImgAvatar = classes.root;
    let classRoot = classes.root;
    if (size) {
        switch (size) {
            case 'small':
                classImgAvatar = cn(classImgAvatar, classes.small);
                classRoot = cn(classRoot, classes.small, classes.noPadding);
                break;
            case 'medium':
                classImgAvatar = cn(classImgAvatar, classes.medium);
                classRoot = cn(classRoot, classes.medium, classes.noPadding);
                break;
            case 'large':
                classImgAvatar = cn(classImgAvatar, classes.large);
                classRoot = cn(classRoot, classes.large);
                break;
            case 'xLarge':
                classImgAvatar = cn(classImgAvatar, classes.xLarge);
                classRoot = cn(classRoot, classes.xLarge);
                break;
            case 'xxLarge':
                classImgAvatar = cn(classImgAvatar, classes.xxLarge);
                classRoot = cn(classRoot, classes.xxLarge);
                break;
            case 'xxLarge1':
                classImgAvatar = cn(classImgAvatar, classes.xxLarge1);
                classRoot = cn(classRoot, classes.xxLarge1);
                break;
            case 'xxxLarge':
                classImgAvatar = cn(classImgAvatar, classes.xxxLarge);
                classRoot = cn(classRoot, classes.xxxLarge);
                break;
        }
    }
    if (marginLeftRight) {
        classRoot = cn(classRoot, classes.marginLeftRight);
    }
    if (marginTopBottom) {
        classRoot = cn(classRoot, classes.marginTopBottom);
    }
    if (marginTopBottom2) {
        classRoot = cn(classRoot, classes.marginTopBottom2);
    }
    if (noMargin) {
        classRoot = cn(classRoot, classes.noMargin);
    }
    if (noMarginLeft) {
        classRoot = cn(classRoot, classes.noMarginLeft);
    }
    if (noMarginRight) {
        classRoot = cn(classRoot, classes.noMarginRight);
    }
    if (className) {
        classAvatar = cn(classAvatar, className);
    }
    return (React.createElement(EdsAvatar, Object.assign({ classes: Object.assign(Object.assign({}, omit(classes, [
            'error',
            'info',
            'success',
            'warning',
            'marginLeftRight',
            'marginTopBottom',
            'marginTopBottom2',
            'noMargin',
            'noMarginLeft',
            'noMarginRight',
            'noPadding',
            'small',
            'medium',
            'large',
            'xLarge',
            'xxLarge',
            'xxLarge1',
            'xxxLarge'
        ])), { img: classImgAvatar, root: classRoot }), className: classAvatar, color: color, ref: ref }, rest), children));
};
const AvatarFRC = forwardRef(Avatar);
AvatarFRC.displayName = 'AvatarFRC';
AvatarFRC.defaultProps = {
    id: '',
    marginLeftRight: true,
    marginTopBottom: true,
    size: 'medium'
};
export default withStyles(styles)(AvatarFRC);
